import { render, staticRenderFns } from "./ScreenLaudoObstetricaDopplerPerfilCervical.vue?vue&type=template&id=75a7a9fc&lang=true&"
import script from "./ScreenLaudoObstetricaDopplerPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoObstetricaDopplerPerfilCervical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports